if (!customElements.get('ticker-bar')) {
  customElements.define(
    'ticker-bar',

    class Ticker extends HTMLElement {
      constructor() {
        super();

        this.resizeEvent = window.theme.debounce(() => this.checkWidth(), 100);
      }

      connectedCallback() {
        this.autoplay = this.hasAttribute('data-autoplay');
        this.scale = this.querySelector('[data-ticker-scale]');
        this.text = this.querySelector('[data-ticker-text]');

        this.comparitor = this.text.cloneNode(true);
        this.comparitor.classList.add('ticker__comparitor');
        this.comparitor.classList.remove('text-highlight-wrapper');
        this.appendChild(this.comparitor);
        this.scale.classList.remove('ticker--unloaded');

        window.addEventListener('orientationchange', this.resizeEvent);
        document.addEventListener('theme:resize:width', this.resizeEvent);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.checkWidth());
        });

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.checkWidth();
          });
        }
      }

      checkWidth() {
        const padding = window.getComputedStyle(this).paddingLeft.replace('px', '') * 2;
        const isOverflowing = this.clientWidth - padding < this.comparitor.clientWidth;

        if (isOverflowing || this.autoplay) {
          let requiredClones = 1;

          if (this.autoplay) {
            const segmentWidth = this.comparitor.clientWidth || this.text.clientWidth;
            const containerWidth = this.clientWidth - padding;

            requiredClones = segmentWidth > 0 ? Math.max(Math.ceil((containerWidth * 2) / segmentWidth), 2) - 1 : 11;
          }

          const targetClones = requiredClones + 2;
          const currentClones = this.scale.querySelectorAll('[data-clone]').length;

          // Rebuild when there aren't enough clones to fill the marquee, or when a
          // smaller viewport has left too many. The band between requiredClones and
          // targetClones prevents rebuilding on every resize tick.
          if (currentClones < requiredClones || currentClones > targetClones) {
            this.scale.querySelectorAll('[data-clone]').forEach((clone) => clone.parentNode.removeChild(clone));
            this.text.classList.remove('ticker--animated');
            this.reflow = this.text.offsetWidth;
            this.text.classList.add('ticker--animated');

            for (let index = 0; index < targetClones; index++) {
              const cloneNode = this.text.cloneNode(true);
              cloneNode.setAttribute('data-clone', '');
              this.scale.appendChild(cloneNode);
            }

            if (this.autoplay) {
              // Add aos-animate class to all elements with data-aos when autoplay is enabled
              this.querySelectorAll('[data-aos]').forEach((element) => {
                element.classList.add('aos-animate');
              });
            }

            let frameSpeed = this.getAttribute('data-marquee-speed');
            if (frameSpeed === null) {
              frameSpeed = 100;
            }

            const moveTime = 1.63;
            const space = 100;
            const speed = moveTime * (100 / parseInt(frameSpeed, 10));
            const animationTimeFrame = (this.text.clientWidth / space) * speed;

            this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`);

            if (!this.animationPauseInitialized) {
              this.animationPauseInitialized = true;
              this.tickerAnimationPause();
            }
          }
        } else {
          const clones = this.scale.querySelectorAll('[data-clone]');
          clones.forEach((clone) => clone.parentNode.removeChild(clone));
          this.text.classList.remove('ticker--animated');
        }
      }

      /**
       * Pauses ticker animation on hover after a short delay
       *
       * This method adds event listeners to pause the ticker animation when
       * the user hovers over it (after a 500ms delay) and resume animation
       * when the mouse leaves the ticker area.
       */
      tickerAnimationPause() {
        let hoverTimer = 0;
        let isHovered = false;

        this.addEventListener('mouseenter', () => {
          isHovered = true;

          hoverTimer = setTimeout(() => {
            if (isHovered) {
              this.querySelectorAll('[data-ticker-text]').forEach((element) => {
                element.style.animationPlayState = 'paused';
              });
            }

            clearTimeout(hoverTimer);
          }, 500);
        });

        this.addEventListener('mouseleave', () => {
          isHovered = false;

          this.querySelectorAll('[data-ticker-text]').forEach((element) => {
            element.style.animationPlayState = 'running';
          });
        });
      }

      disconnectedCallback() {
        window.removeEventListener('orientationchange', this.resizeEvent);
        document.removeEventListener('theme:resize:width', this.resizeEvent);
      }
    }
  );
}
